import { render } from "./Batches_Show.vue?vue&type=template&id=ea69ced8&scoped=true"
import script from "./Batches_Show.vue?vue&type=script&lang=js"
export * from "./Batches_Show.vue?vue&type=script&lang=js"

import "./Batches_Show.vue?vue&type=style&index=0&id=ea69ced8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea69ced8"]])

export default __exports__